import React from 'react';
import Link from 'next/link';

const WaysToWear = (data: any) => {
  return (
    <>
      {data?.data?.CSData?.dataSource?.carouselItemEntries?.map((entry: any, indx: number) => {
        if (entry.title === `${data?.data?.CSData?.dataSource?.brandSiteID} - ${data?.data?.contentStackTitle}`) {
          return (
            <React.Fragment key={indx}>
              <h2 className="pb-4 pt-10 text-center text-lg font-bold leading-7 lg:pb-9 lg:pt-16 lg:text-[22px]">
                {data?.data?.contentStackTitle}
              </h2>
              <section className="grid grid-cols-2 gap-5 lg:grid-cols-4">
                {entry?.item.map((item: any, indx: number) => {
                  return (
                    <section key={indx}>
                      <section className="flex items-center justify-center border border-foggyGray">
                        <Link title={item?.item_link.title} href={item?.item_link?.href}>
                          <img className="w-full" src={item?.item_image?.url} alt={item?.item_title} />
                        </Link>
                      </section>
                      <section className="py-4 text-center">
                        <Link title={item?.item_link.title} href={item?.item_link?.href}>
                          <strong className="text-base font-bold leading-6 lg:text-lg">{item?.item_title}</strong>
                        </Link>
                        <p className="pt-1 text-sm lg:pt-3 lg:text-base">
                          <Link title={item?.item_link.title} href={item?.item_link?.href}>
                            {item?.item_description}
                          </Link>
                        </p>
                      </section>
                    </section>
                  );
                })}
              </section>
            </React.Fragment>
          );
        }
      })}
    </>
  );
};

export default WaysToWear;
